import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: 'calc(50vh - 150px)',
  },
  message: {
    marginBottom: theme.spacing(5),
    width: 350,
    [theme.breakpoints.down('md')]: {
      width: 210,
    },
  },
  button: {
    width: 146,
    minHeight: 46,
    [theme.breakpoints.down('lg')]: {
      width: 170,
      minHeight: 44,
    },
  },
}));
